module.exports = __webpack_public_path__ + "img/angola.b508f67f.svg";